<script lang="ts" setup>
import { isSameDate } from '@/utilities/dateutils';
import DateComp from '@/components/Basic/DateComp.vue';
import { parseDateStringISO } from '@/utilities/dateutils';

const props = defineProps<{
    first: Date | null;
    second: Date | null;
}>();
</script>

<template>
    <span>
        <template v-if="first && second && isSameDate(parseDateStringISO(first), parseDateStringISO(second))">
            <DateComp
                :value="first"
                format="TIME"
            />
            -
            <DateComp
                :value="second"
                format="TIME"
            />
        </template>
        <template v-else-if="first && second">
            <DateComp
                :value="first"
                format="DATETIME"
            />
            -
            <DateComp
                :value="second"
                format="DATETIME"
            />
        </template>
        <template v-else-if="first">
            <DateComp
                :value="first"
                format="DATETIME"
            />
            -
            {{ $tm('general.forever') }}
        </template>
        <template v-else>
            {{ $tm('general.none') }}
        </template>
    </span>
</template>
